import { render } from "./ClipboardButton.vue?vue&type=template&id=e16b40d4&scoped=true"
import script from "./ClipboardButton.vue?vue&type=script&lang=js"
export * from "./ClipboardButton.vue?vue&type=script&lang=js"

import "./ClipboardButton.vue?vue&type=style&index=0&id=e16b40d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16b40d4"]])

export default __exports__